import { render, staticRenderFns } from "./OverduePage.vue?vue&type=template&id=f6b53232&scoped=true"
import script from "./OverduePage.vue?vue&type=script&lang=js"
export * from "./OverduePage.vue?vue&type=script&lang=js"
import style0 from "./OverduePage.vue?vue&type=style&index=0&id=f6b53232&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b53232",
  null
  
)

export default component.exports